<template>
  <div>
    <b-card
      no-body
      class="my-1"
      :class="{ 'card-transparent-background': type == 'register' }"
    >
      <b-card-header
        class="card-header-form-doorder"
        :class="{ 'card-header-profile-border': type == 'profile' }"
        ><h4>Payment Details</h4></b-card-header
      >
      <b-card-body class="py-0">
        <div class="container">
          <b-row>
            <b-col md="12" class="mb-2">
              <b-row class="mb-2">
                <b-col>
                  <b-form-group
                    class="form-group-checkbox-group form-group-check-doorder"
                  >
                    <b-form-checkbox
                      id="require_card"
                      v-model="require_card"
                      name="require_card"
                      value="true"
                      unchecked-value="false"
                    >
                      Add card details?
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <StripeComponentPayment
                ref="stripe_component"
                client_name="Doorder"
                :require_card="require_card"
                :stripe_token.sync = "stripe_token"
                element_class_base="form-control form-control-doorder"
                form_group_class="form-group-doorder"
              />
            </b-col>
          </b-row>
        </div>
      </b-card-body>

      <!-- <b-card-body class="pt-0">
        <div class="container">
          <b-row>
            <b-col
              md="12"
              class="my-2 profile-border-div mb-4"
              v-for="(contact, index) in contacts"
              :key="contact.id"
            >
              <b-row>
                <b-col sm="6">
                  <b-form-group
                    :label="type == 'register' ? '' : 'Contact name'"
                    :label-for="'contact_name' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <b-form-input
                      :id="'contact_name' + (index + 1)"
                      class="form-control-doorder"
                      v-model="contact.contact_name"
                      :name="'contact_name' + (index + 1)"
                      placeholder="Contact name"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group
                    class="mobile-number-input-group-doorder"
                    :label="type == 'register' ? '' : 'Contact number'"
                    :label-for="'contact_number' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <vue-tel-input
                      class="form-control form-control-doorder"
                      :id="'contact_number' + (index + 1)"
                      v-model="contact.contact_number"
                      required
                    ></vue-tel-input>
                  </b-form-group>
                
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group
                    :label="type == 'register' ? '' : 'Contact email'"
                    :label-for="'contact_email' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <b-form-input
                      :id="'contact_email' + (index + 1)"
                      class="form-control-doorder"
                      v-model="contact.contact_email"
                      :name="'contact_email' + (index + 1)"
                      placeholder="Contact email address"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    class="form-group-doorder"
                    :label="type == 'register' ? '' : 'Location'"
                    :label-for="'location' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      class="error_validation_message_p"
                      v-if="invalid_location"
                    >
                      Please select location
                    </p>
                    <v-select
                      :options="locations"
                      v-model="contact.location"
                      :name="'location' + (index + 1)"
                      placeholder="Select location"
                      required
                      label="eircode"
                      :reduce="location => location.eircode"
                    >
                    </v-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-card-body> -->
    </b-card>
  </div>
</template>
 
<script>
import $ from "jquery";
import moment from "moment";
import StripeComponentPayment from "@/components/Payment/StripeComponentPayment";

export default {
  name: "PaymentDetails",

  components: { StripeComponentPayment },
  props: ["type", "require_card","stripe_token"],
  data() {
    return {};
  },
  mounted() {},
  updated() {
    console.log(this.require_card);
    this.$emit("update:require_card", this.require_card);
    
    console.log(this.stripe_token);
    this.$emit("update:stripe_token", this.stripe_token);
  },
  methods: {
    testtest(){
      console.log("click testtest")
    }
  },
};
</script>

<style >
</style>


// WEBPACK FOOTER //
// src/components/doorder/retailers/profile_details_components/PaymentDetails.vue